/* eslint-disable */
const templateContents = `<p style="line-height:1.38"><span style="font-size:15px;color:#000000;">Name:&nbsp;</span></p>
  <p style="line-height:1.38"><span style="font-size:15px;color:#000000;">Handle:</span><span
      style="font-size:15px;color:#000000;"><br></span><span style="font-size:15px;color:#000000;">Platform:</span><span
      style="font-size:15px;color:#000000;"><br></span><span style="font-size:15px;color:#000000;">Campaign:</span></p>
  <p style="line-height:1.38"><br></p>
  <p style="line-height:1.38"><span style="font-size:15px;color:#ff0000;">Submission Date:</span></p>
  <p style="line-height:1.38"><br></p>
  <p style="line-height:1.38"><span style="font-size:15px;color:#000000;">IG Reel/ TT</span></p>
  <p style="line-height:1.38"><br></p>
  <p style="line-height:1.38"><span style="font-size:15px;color:#000000;">Concept:&nbsp;</span></p>
  <p style="line-height:1.38"><span style="font-size:15px;color:#000000;">Reason for concept:&nbsp;</span></p>
  <p style="line-height:1.38"><span style="font-size:15px;color:#000000;">Music choice if any:&nbsp;</span></p>
  <p style="line-height:1.38"><br></p>
  <div style="margin-left:0pt">
    <table>
      <tbody>
        <tr>
          <td>
            <p style="line-height:1.2"><span style="font-size:15px;color:#000000;">Descriptions of scenes/ footage</span>
            </p>
          </td>
          <td>
            <p style="line-height:1.2"><span style="font-size:15px;color:#000000;">Include text overlays / voiceover
                script in each scene</span></p>
          </td>
          <td>
            <p style="line-height:1.2"><span style="font-size:15px;color:#000000;">Reference links/images&nbsp;</span></p>
          </td>
        </tr>
        <tr>
          <td>
            <p style="line-height:1.2"><span style="font-size:9px;color:#999999;">INTRO: (can be hook/ theme/ title of
                your video)&nbsp;</span></p><br>
            <p style="line-height:1.2"><span style="font-size:9px;color:#999999;">What will make your audience want to
                watch this content?&nbsp;</span></p><br>
            <p style="line-height:1.2"><span style="font-size:9px;color:#999999;">Scene 1:</span></p>
          </td>
          <td>
            <p style="line-height:1.38"><span style="font-size:9px;color:#999999;">Text:&nbsp;</span></p>
            <p style="line-height:1.38"><span style="font-size:9px;color:#999999;">VO:&nbsp;</span></p><br>
            <p style="line-height:1.38"><span style="font-size:9px;color:#999999;">Relate 2-3 pointers of brief into your
                concept (keep it less ad-like, DO NOT COPY USPs from the campaign brief)</span></p><br>
          </td>
          <td rowspan="3">
            <p style="line-height:1.2"><span style="font-size:9px;color:#999999;">Share a content piece that best
                describes your content script</span></p>
            <p style="line-height:1.2"><span style="font-size:9px;color:#999999;">(can be existing link/ image/ GIF/ self
                demo)&nbsp;&nbsp;</span></p>
          </td>
        </tr>
        <tr>
          <td>
            <p style="line-height:1.38"><span style="font-size:9px;color:#999999;">BODY</span></p>
            <p style="line-height:1.38"><span style="font-size:9px;color:#999999;">Showcase how you plan to execute every
                scene and how you’ll feature the product/service that relates to the campaign brief.</span></p>
            <p style="line-height:1.38"><span style="font-size:9px;color:#999999;">*Not every scene needs to have the
                product/ USPs</span></p><br>
            <p style="line-height:1.38"><span style="font-size:9px;color:#999999;">Scene 2:</span></p><br><br><br>
            <p style="line-height:1.38"><span style="font-size:9px;color:#999999;">Scene 3:</span></p><br><br><br>
            <p style="line-height:1.38"><span style="font-size:9px;color:#999999;">Scene 4:</span></p><br><br><br>
            <p style="line-height:1.38"><span style="font-size:9px;color:#999999;">Scene 5:</span></p><br><br><br>
            <p style="line-height:1.38"><span style="font-size:9px;color:#999999;">Scene 6:</span></p><br><br>
            <p style="line-height:1.38"><span style="font-size:9px;color:#999999;">Scene 7:</span></p><br>
          </td>
          <td>
            <p style="line-height:1.38"><span style="font-size:9px;color:#999999;">Text:&nbsp;</span></p>
            <p style="line-height:1.38"><span style="font-size:9px;color:#999999;">VO:&nbsp;</span></p><br>
            <p style="line-height:1.38"><span style="font-size:9px;color:#999999;">Relate 2-3 pointers of brief into your
                concept (keep it less ad-like, DO NOT COPY USPs from the campaign brief)</span></p><br>
          </td>
        </tr>
        <tr>
          <td>
            <p style="line-height:1.2"><span style="font-size:9px;color:#999999;">CTA - Call To Action&nbsp;</span></p>
            <br><br>
            <p style="line-height:1.38"><span style="font-size:9px;color:#999999;">Scene 8:</span></p><br>
          </td>
          <td>
            <div><br></div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <p style="line-height:1.38"><span style="font-size:16px;color:#000000;"><br></span><span
      style="font-size:15px;color:#000000;">IG Story</span></p>
  <p style="line-height:1.38"><span style="font-size:15px;color:#000000;">&nbsp;</span></p>
  <p style="line-height:1.38"><span style="font-size:15px;color:#000000;">Any Story functions used?&nbsp;</span></p>
  <p style="line-height:1.38"><span style="font-size:15px;color:#000000;">Polling/ AMA/ Quiz/ Link</span></p>
  <p style="line-height:1.38"><br></p>
  <p style="line-height:1.38"><span style="font-size:15px;color:#000000;">Music choice if any:&nbsp;</span></p>
  <div style="margin-left:0pt">
    <table>
      <tbody>
        <tr>
          <td>
            <p style="line-height:1.2"><span style="font-size:15px;color:#000000;">Descriptions of scenes</span></p>
          </td>
          <td>
            <p style="line-height:1.2"><span style="font-size:15px;color:#000000;">Include text overlays / voiceover
                script in each scene</span></p>
          </td>
          <td>
            <p style="line-height:1.2"><span style="font-size:15px;color:#000000;">Reference links/images&nbsp;</span></p>
          </td>
        </tr>
        <tr>
          <td>
            <p style="line-height:1.2"><span style="font-size:9px;color:#999999;">INTRO: (can be hook/ theme/ title of
                your video)&nbsp;</span></p><br>
            <p style="line-height:1.2"><span style="font-size:9px;color:#999999;">What will make your audience not skip
                your story?&nbsp;</span></p><br><br>
          </td>
          <td>
            <p style="line-height:1.38"><span style="font-size:9px;color:#999999;">Text:&nbsp;</span></p>
            <p style="line-height:1.38"><span style="font-size:9px;color:#999999;">VO:&nbsp;</span></p><br>
            <p style="line-height:1.38"><span style="font-size:9px;color:#999999;">Relate 2-3 pointers of brief into your
                concept (keep it less ad-like, DO NOT COPY USPs from the campaign brief)</span></p>
          </td>
          <td rowspan="3">
            <p style="line-height:1.2"><span style="font-size:9px;color:#999999;">Share a content piece that best
                describes your content script</span></p>
            <p style="line-height:1.2"><span style="font-size:9px;color:#999999;">(can be existing link/ image/ GIF/ self
                demo)&nbsp;&nbsp;</span></p>
          </td>
        </tr>
        <tr>
          <td>
            <div><br></div>
          </td>
          <td>
            <p style="line-height:1.38"><span style="font-size:9px;color:#999999;">Text:&nbsp;</span></p>
            <p style="line-height:1.38"><span style="font-size:9px;color:#999999;">VO:&nbsp;</span></p><br>
            <p style="line-height:1.38"><span style="font-size:9px;color:#999999;">Relate 2-3 pointers of brief into your
                concept (keep it less ad-like, DO NOT COPY USPs from the campaign brief)</span></p>
          </td>
        </tr>
        <tr>
          <td>
            <p style="line-height:1.2"><span style="font-size:9px;color:#999999;">CTA - Call To Action&nbsp;</span></p>
            <br><br><br>
          </td>
          <td>
            <p style="line-height:1.2"><span style="font-size:9px;color:#999999;">Let us know your text display of your
                link sticker that’ll entice your audience to click&nbsp; (if required):</span><span
                style="font-size:9px;color:#999999;"><br><br></span></p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <p style="line-height:1.38"><span style="font-size:15px;color:#000000;">IG Carousel</span></p>
  <p style="line-height:1.38"><span style="font-size:15px;color:#000000;">&nbsp;</span></p>
  <div style="margin-left:0pt">
    <table>
      <tbody>
        <tr>
          <td>
            <p style="line-height:1.2"><span style="font-size:15px;color:#000000;">IMAGE</span></p>
          </td>
          <td>
            <p style="line-height:1.2"><span style="font-size:15px;color:#000000;">Description of image/gif</span></p>
          </td>
          <td>
            <p style="line-height:1.2"><span style="font-size:15px;color:#000000;">Text on image (if any)</span></p>
          </td>
          <td>
            <p style="line-height:1.2"><span style="font-size:15px;color:#000000;">Reference image</span></p>
          </td>
        </tr>
        <tr>
          <td>
            <p style="line-height:1.38"><span style="font-size:15px;color:#000000;">1</span></p>
          </td>
          <td>
            <div><br></div>
          </td>
          <td>
            <div><br></div>
          </td>
          <td>
            <p style="line-height:1.2"><span style="font-size:9px;color:#999999;">Share a content piece that best
                describes your content script</span></p>
            <p style="line-height:1.2"><span style="font-size:9px;color:#999999;">(can be existing link/ image/ GIF/ self
                demo)&nbsp;&nbsp;</span></p>
          </td>
        </tr>
        <tr>
          <td>
            <p style="line-height:1.38"><span style="font-size:15px;color:#000000;">2</span></p><br>
          </td>
          <td>
            <div><br></div>
          </td>
          <td>
            <div><br></div>
          </td>
          <td>
            <div><br></div>
          </td>
        </tr>
        <tr>
          <td>
            <p style="line-height:1.2"><span style="font-size:15px;color:#000000;">3</span></p>
          </td>
          <td>
            <div><br></div>
          </td>
          <td>
            <div><br></div>
          </td>
          <td>
            <div><br></div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <p style="line-height:1.38"><span style="font-size:15px;color:#000000;">Caption:&nbsp;</span></p>
  <p style="line-height:1.38"><span style="font-size:15px;color:#000000;">(Include mandatory hashtags and mentions needed
      for campaign)</span></p>
  <div style="margin-left:-49.5pt">
    <table>
      <tbody>
        <tr>
          <td>
            <p style="line-height:1.2"><span style="font-size:15px;color:#000000;">1st pic&nbsp;</span></p>
          </td>
          <td>
            <p style="line-height:1.2"><span style="font-size:15px;color:#000000;">2nd Pic&nbsp;&nbsp;</span></p>
          </td>
          <td>
            <p style="line-height:1.2"><span style="font-size:15px;color:#000000;">3rd Pic</span></p>
          </td>
          <td>
            <p style="line-height:1.2"><span style="font-size:15px;color:#000000;">4th pic&nbsp;</span></p>
          </td>
          <td>
            <p style="line-height:1.2"><span style="font-size:15px;color:#000000;">5th pic&nbsp; or more</span></p>
          </td>
        </tr>
        <tr>
          <td>
            <p style="line-height:1.2"><span style="font-size:15px;color:#999999;">Description of image/gif:&nbsp;</span>
            </p>
          </td>
          <td>
            <p style="line-height:1.2"><span style="font-size:15px;color:#999999;">Description of image/gif:&nbsp;</span>
            </p>
          </td>
          <td>
            <p style="line-height:1.2"><span style="font-size:15px;color:#999999;">Description of image/gif:&nbsp;</span>
            </p>
          </td>
          <td>
            <p style="line-height:1.2"><span style="font-size:15px;color:#999999;">Description of image/gif:&nbsp;</span>
            </p>
          </td>
          <td>
            <p style="line-height:1.2"><span style="font-size:15px;color:#999999;">Description of image/gif:&nbsp;</span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p style="line-height:1.2"><span style="font-size:15px;color:#999999;">Text on image (if any):&nbsp;</span>
            </p>
          </td>
          <td>
            <p style="line-height:1.2"><span style="font-size:15px;color:#999999;">Text on image (if any):&nbsp;</span>
            </p>
          </td>
          <td>
            <p style="line-height:1.2"><span style="font-size:15px;color:#999999;">Text on image (if any):&nbsp;</span>
            </p>
          </td>
          <td>
            <p style="line-height:1.2"><span style="font-size:15px;color:#999999;">Text on image (if any):&nbsp;</span>
            </p>
          </td>
          <td>
            <p style="line-height:1.2"><span style="font-size:15px;color:#999999;">Text on image (if any):&nbsp;</span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p style="line-height:1.2"><span style="font-size:15px;color:#0000ff;">Reference image:</span></p><br>
            <p style="line-height:1.2"><span style="font-size:9px;color:#0000ff;">Share a content piece that best
                describes your content script</span></p>
            <p style="line-height:1.2"><span style="font-size:9px;color:#0000ff;">(can be existing link/ image/ GIF/ self
                demo)&nbsp;&nbsp;</span></p>
          </td>
          <td>
            <p style="line-height:1.2"><span style="font-size:15px;color:#0000ff;">Reference image:</span></p><br>
            <p style="line-height:1.2"><span style="font-size:9px;color:#0000ff;">Share a content piece that best
                describes your content script</span></p>
            <p style="line-height:1.2"><span style="font-size:9px;color:#0000ff;">(can be existing link/ image/ GIF/ self
                demo)&nbsp;&nbsp;</span></p>
          </td>
          <td>
            <p style="line-height:1.2"><span style="font-size:15px;color:#0000ff;">Reference image:</span></p><br>
            <p style="line-height:1.2"><span style="font-size:9px;color:#0000ff;">Share a content piece that best
                describes your content script</span></p>
            <p style="line-height:1.2"><span style="font-size:9px;color:#0000ff;">(can be existing link/ image/ GIF/ self
                demo)&nbsp;&nbsp;</span></p>
          </td>
          <td>
            <p style="line-height:1.2"><span style="font-size:15px;color:#0000ff;">Reference image:</span></p><br>
            <p style="line-height:1.2"><span style="font-size:9px;color:#0000ff;">Share a content piece that best
                describes your content script</span></p>
            <p style="line-height:1.2"><span style="font-size:9px;color:#0000ff;">(can be existing link/ image/ GIF/ self
                demo)&nbsp;&nbsp;</span></p>
          </td>
          <td>
            <p style="line-height:1.2"><span style="font-size:15px;color:#0000ff;">Reference image:</span></p><br>
            <p style="line-height:1.2"><span style="font-size:9px;color:#0000ff;">Share a content piece that best
                describes your content script</span></p>
            <p style="line-height:1.2"><span style="font-size:9px;color:#0000ff;">(can be existing link/ image/ GIF/ self
                demo)&nbsp;&nbsp;</span></p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>`

  export default Object.assign({}, {
    templateContents
  })
  


// WEBPACK FOOTER //
// ./src/components/views/Pairing/CreatorConcept/template.js